<template>
    <div class="project">
        <a @click="openLink(`${project.slug_hu}`)">
            <p class="title">{{ title }}</p>

            <span class="location">
                <span class="mobile-label">Location</span> {{ project.country }} {{ project.city }}</span>
            <span class="size"><span class="mobile-label">Size</span> {{ project.size }}</span>
            <span class="date"><span class="mobile-label">Date</span> {{ getDate(project) }}</span>
            <div class="lastimage">
                <div v-if="project.files.length === 0" class="no-images"></div>
                <div v-for="(file, index) in project.files" :key="file.id">
                    <img v-if="lastactive === index" :src="'/files-thumb/' + file.thumbnail" alt="" />
                </div>
            </div>

            <div class="image">
                <div v-if="project.files.length === 0" class="no-images"></div>
                <div v-for="(file, index) in project.files" :key="file.id">
                    <img v-if="active === index" @load="activeImageLoaded(index)"
                        :src="'/files-thumb/' + file.thumbnail" alt="" />
                </div>
            </div>
            <div class="slideshow">
                <div v-for="(file, index) in project.files" :key="file.id" @mouseover="setImage(index)"
                    @click="window.location.href = `/${currentLanguage}/projects/${project.slug_hu}`"></div>
            </div>
        </a>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    mounted() {
        this.activeImageLoaded(0);
        this.setImage(0);
    },
    props: {
        project: {
            type: Object,
            required: true,
        },
    },
    computed: {
        title() {
            return this.project[`title_${this.currentLanguage}`] || this.project.title_en;
        },
        showImage() {
            return this.$refs.image;
        },
    },
    methods: {
        openLink(slug, newTab = false) {
            let path = '';
            switch (this.currentLanguage) {
                case 'hu':
                    path = '/hu/projects/' + slug;
                    break;
                case 'en':
                    path = '/en/projects/' + slug;
                    break;
                case 'de':
                    path = '/de/projects/' + slug;
                    break;
                default:
                    path = '/en/projects/' + slug;
            }

            window.open(path, newTab ? '_blank' : '_self');
        },

        setImage(index) {
            this.active = index;
        },
        activeImageLoaded(index) {
            this.lastactive = index;
        },
        getDate(project) {
            var dateString = moment(project.start).format('YYYY');
            if (project.end) dateString += ' - ' + moment(project.end).format('YYYY');
            return dateString;
        },
    },
    data() {
        return {
            active: 0,
            lastactive: 0,
            currentLanguage: window.currentLocale,
        };
    },
};
</script>

<style lang="scss" scoped>
@import './../../sass/variables';

.no-images {
    background-image: url('/img/default-project.jpg');
    background-size: cover;
}

.slideshow {
    position: absolute;
    display: flex;
    height: 100%;
    z-index: 10;
    width: 100%;
    left: 0;
    top: 0;

    @media screen and (max-width: $tablet-max) {
        display: none;
    }

    div {
        flex: 1;
    }
}

a {
    cursor: pointer;
    background-position: center;
    background-size: cover;
}

h3,
span {
    position: relative;
    z-index: 3;
}

.image {
    .no-images,
    img {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 2;
        left: 0;
        top: 0;
    }
}

.lastimage {
    .no-images,
    img {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 1;
        left: 0;
        top: 0;
    }
}
</style>
